module.exports = __webpack_public_path__ + "img/login_page_logo.f9d17fe3.png";